export default {"src":"/_next/static/media/feedback-star-green.28091b13.svg","height":16,"width":18,"blurWidth":0,"blurHeight":0};